import { useQuery } from "@tanstack/react-query";
import { AxiosResponse } from "axios";

import { taskQuery } from "../../utils";

import { TaskResponse } from "../../typings";

export const useTask = (id: { taskId: string; examId?: string }) =>
    useQuery<AxiosResponse<TaskResponse, any>>(taskQuery(id));
